/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { GiftWithPurchaseType, IGiftWithPurchaseViewProps } from './gift-with-purchase';
import { Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import { ProductSearchResult } from '@msdyn365-commerce/retail-proxy';

import ProductComponent from '../../themes/venchi/views/components/product.component';

const GiftWithPurchaseView: React.FC<IGiftWithPurchaseViewProps> = (props: IGiftWithPurchaseViewProps) => {
    const { promotionProps, modalVisible, context, config, resources } = props;
    if (!promotionProps) {
        return null;
    }
    const tempProducts = promotionProps && promotionProps.productSelection && promotionProps.productSelection.length > 0 && (
        <ul className='row'>
            {promotionProps.productSelection.map((product: ProductSearchResult, index: number) => (
                <li key={index}>
                    {promotionProps.gwpType === GiftWithPurchaseType.AUTO ? (
                        <p className='venchi-gwp__free-count-label'>
                            +{promotionProps.numberProductsOfGift} {config.modalFreeLabel?.toUpperCase()}
                        </p>
                    ) : null}
                    <div className='ms-product-search-result__item'>
                        <ProductComponent
                            context={context}
                            imageSettings={config.imageSettings}
                            allowBack={false}
                            id='gwp__0'
                            key={product.RecordId}
                            typeName='product-collection'
                            data={{ product }}
                            resources={resources}
                        />
                    </div>
                </li>
            ))}
        </ul>
    );
    return (
        <Modal
            id={'gwpModal'}
            isOpen={modalVisible}
            autoFocus
            fade={false}
            verticalPosition='top'
            toggle={props.closePopupCallback}
            modalClassName='text-center venchi-gwp'
        >
            <ModalHeader toggle={props.closePopupCallback}>{config.modalHeader}</ModalHeader>
            <div className={'venchi_popup'}>
                <ModalBody>
                    <div className='venchi-gwp__body'>
                        <p>{config.modalMainText}</p>
                        {tempProducts}
                    </div>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default GiftWithPurchaseView;
